/**
 * @module project/components/entry_details/entry_details_revision
 */
import React, { PropTypes } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { v4 } from 'node-uuid';
import Icon from 'common/components/svg_icon';
import Thumbnail from 'common/components/thumbnail';


/**
 * Entry details revisions component
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const EntryDetailsRevisions = (props) => {
  const { entry, currentRevision,
    onRevisionChange, onCloseRevisions } = props;

  return (
    <div className="entry-revisions-list">
      <div className="show-for-small-only button-wrapper">
        <button
          type="button"
          onClick={onCloseRevisions}
          className="btn btn-icon-only btn-close"
        >
          <Icon className={classNames('svg-icon', 'svg-icon-sm')} icon="close"/>
        </button>
      </div>
      <div className="list-title">
        <h3>Select Version</h3>
      </div>
      <ul>
        { entry.revisions.map((revision, idx) => {
          return (
            <li key={v4()} className="revision">
              <span className={classNames('revision-date', { 'most-recent': idx === 0 })}>
              { idx === 0 ?
                'Most Recent' :
                moment(revision.created_at).fromNow()
              }
              </span>
              <Thumbnail
                onClick={() => { onRevisionChange(revision.id); }}
                className={classNames('tile thumbnail flex actionable', {
                  selected: (revision.id === currentRevision) || (!currentRevision && idx === 0),
                })}
                image={revision.thumbnails[0]}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

/**
 * PropTypes.
 *
 * @property {object} entry - entry data object
 * @property {object} currentRevision - id of currently selected revision
 * @property {object} onRevisionChange - action creator called when revision is changed
 * @property {object} onCloseRevisions - function called when revisions panel is hidden
 */
EntryDetailsRevisions.propTypes = {
  entry: PropTypes.object,
  currentRevision: PropTypes.number,
  onRevisionChange: PropTypes.func,
  onCloseRevisions: PropTypes.func,
};

export default EntryDetailsRevisions;



// WEBPACK FOOTER //
// ./project/components/entry_details/entry_details_revisions.jsx